import React, { useState } from 'react';
import './ContactUs.css';
import contactBg1 from './img/contact-bg1.png';

// Icons
import { BsFillTelephoneFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";

const ContactUs = () => {
    const [formData, setFormData] = useState({
        FIRSTNAME: '',
        LASTNAME: '',
        EMAIL: '',
        SUBJECT: '',
        MESSAGE: '',
    });

    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e: any) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault(); // prevent the default form behavior

        try {
            const response = await fetch('https://d427d68c.sibforms.com/serve/MUIFAJ7LN787nIZVF7H32AyR1Da_R8rYohWir2ULF3x9vjBsdV9K1cB4IMftxdadimgbcm8aNKcewlcqWp9mCBQYJ67b48BdYL-hzwMv_rij9bOXLHGqnk9eAtU8DfTOZ-tsh3lW20TufJwf55YvdiB3dCZHrcLjTAJ0oVMEuQIuJXPd3xUXlJdzODi6dwW-lDzfzullMPnAQ25D', {
                method: 'POST',
                mode: 'no-cors',  // Important because Sendinblue won't return CORS headers
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams(formData).toString(),
            });

            setSubmitted(true);
            setError('');

            // Reset form after 6 seconds
            setTimeout(() => {
                setSubmitted(false);
                setFormData({
                    FIRSTNAME: '',
                    LASTNAME: '',
                    EMAIL: '',
                    SUBJECT: '',
                    MESSAGE: ''
                });
            }, 6000); // 6 seconds delay
        } catch (err) {
            console.error('Error submitting the form:', err);
            setError('Something went wrong. Please try again.');
        }
    };

    return (
        <div className="home-container">
            <div className="contact-hero-section">
                <img className="contact-hero-image" alt="hero background" src={contactBg1} />

                <div className="dark-overlay"></div> {/* ← Overlay */}

                <div className="overall-contact-wrapper">
                    <div className="contact-plus-prompt">
                        <h1>Contact Us</h1>
                        <p>Want to get in contact? Fill out this form and we’ll get back to you as soon as we can.</p>
                        <h2>HELIOS POMPANO INC</h2>
                    </div>

                    <div className="contact-location-card-stack">
                        <div className="location-card">
                            <h1>Headquarters</h1>
                            <p className='contact-address'>
                                747 SW 2nd Avenue <br />
                                Suite 169 <br />
                                Gainesville, FL 32601 <br />
                                United States of America
                            </p>
                            <p className='contact-phone'><BsFillTelephoneFill style={{ width: '1.3rem', height: '1.3rem'}} />+1 (954)-681-1770 </p>
                        </div>

                        <div className="location-card">
                            <h1>South Florida Office</h1>
                            <p className='contact-address'>
                                2226 N.Cypress Bend Dr.<br />
                                Suite 209 <br />
                                Pompano Beach, FL 33069 <br />
                                United States of America
                            </p>
                            <p className='contact-phone2'><BsFillTelephoneFill style={{ width: '1.3rem', height: '1.3rem', marginLeft:'0.4rem'}} />+1 (954)-681-1770 </p>
                            <p className='contact-email'><MdEmail style={{ width: '2rem', height: '2rem' }} />info@fireneuralnetwork.com</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="get-in-touch-wrapper">
                <h1 style={{ color: '#28AAE1', fontWeight: '700' }}>Get In Touch</h1>
                <div id="sib-container" className="sib-container--large sib-container--vertical">
                    {submitted ? (
                        <h2 className="success-message">Thank you for contacting us!</h2>
                    ) : (
                        <form id="sib-form" onSubmit={handleSubmit}>
                            {/* First Name */}
                            <div>
                                <div className="sib-input sib-form-block">
                                    <input
                                        className="sibs-input"
                                        maxLength={200}
                                        type="text"
                                        name="FIRSTNAME"
                                        placeholder="First Name"
                                        value={formData.FIRSTNAME}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>

                            {/* Last Name */}
                            <div>
                                <div className="sib-input sib-form-block">
                                    <input
                                        className="sibs-input"
                                        maxLength={200}
                                        type="text"
                                        name="LASTNAME"
                                        placeholder="Last Name"
                                        value={formData.LASTNAME}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>

                            {/* Email */}
                            <div>
                                <div className="sib-input sib-form-block">
                                    <input
                                        className="sibs-input"
                                        type="email"
                                        name="EMAIL"
                                        placeholder="Email"
                                        value={formData.EMAIL}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>

                            <div>
                                <div className="sib-input sib-form-block">
                                    <label>
                                        Subject<span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <select
                                        className="sibs-input sibs-select-input"
                                        name="SUBJECT"
                                        value={formData.SUBJECT}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="" disabled>Select One</option>
                                        <option value="General Inquiry/Introduction">General Inquiry/Introduction</option>
                                        <option value="Detector Deployment Inquiry">Detector Deployment Inquiry</option>
                                        <option value="Employment/Internship Inquiry">Employment/Internship Inquiry</option>
                                    </select>
                                </div>
                            </div>


                            {/* Message */}
                            <div>
                                <div className="sib-input sib-form-block">
                                    <label>Message<span style={{ color: 'red' }}>*</span> </label>
                                    <textarea
                                        className="sibs-input"
                                        name="MESSAGE"
                                        placeholder="Leave a Message"
                                        rows={4}
                                        style={{ resize: 'vertical' }}
                                        value={formData.MESSAGE}
                                        onChange={handleChange}
                                        required
                                    ></textarea>
                                    <p style={{marginTop:'0.5rem'}}><strong>Customize your message to help us understand your request.</strong></p>
                                </div>
                            </div>

                            {/* Submit Button */}
                            <div>
                                <button
                                    className="sibs-submit-button"
                                    type="submit"
                                >
                                    Submit
                                </button>
                            </div>

                            {error && <p className="error-message">{error}</p>}
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ContactUs;
